import { Injectable } from '@angular/core';
import {DataCoreService, FormLabelLocationEnum, FormLabelModeEnum} from "@dabnet-kamu/libs/ui";
import {FormLabelMode, LabelLocation} from "devextreme/ui/form";

@Injectable({
  providedIn: 'root',
})
export class DkGlobalUserSettingsService {

  globalLabelLocation: LabelLocation = FormLabelLocationEnum.Left ;
  globalLabelMode: FormLabelMode = FormLabelModeEnum.Outside;
  constructor(private dataCoreService: DataCoreService) {}


}
